"use strict";
// (C) 2022-2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.GranularPermissionsDropdownBody = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var GranularPermissionItem_1 = require("./GranularPermissionItem");
var List_1 = require("../../../../List");
var Overlay_1 = require("../../../../Overlay");
var Bubble_1 = require("../../../../Bubble");
var locales_1 = require("../../../../locales");
var ComponentInteractionContext_1 = require("../ComponentInteractionContext");
var overlayAlignPoints = [{ align: "br tr" }];
var RemoveItem = function (_a) {
    var disabled = _a.disabled, tooltipId = _a.tooltipId, onClick = _a.onClick;
    var className = classnames_1.default("gd-list-item gd-menu-item", "s-granular-permission-remove", {
        "is-disabled": disabled,
    });
    var FormattedMessageWithBubble = Bubble_1.withBubble(react_intl_1.FormattedMessage);
    return (react_1.default.createElement("div", { className: className, onClick: onClick },
        react_1.default.createElement(FormattedMessageWithBubble, { id: locales_1.granularPermissionMessageLabels.remove.id, showBubble: disabled, bubbleTextId: tooltipId })));
};
exports.GranularPermissionsDropdownBody = function (_a) {
    var grantee = _a.grantee, granteePossibilities = _a.granteePossibilities, alignTo = _a.alignTo, isShowDropdown = _a.isShowDropdown, selectedPermission = _a.selectedPermission, toggleDropdown = _a.toggleDropdown, onChange = _a.onChange, onDelete = _a.onDelete, handleSetSelectedPermission = _a.handleSetSelectedPermission, mode = _a.mode;
    var _b = ComponentInteractionContext_1.useShareDialogInteraction(), permissionsChangeInteraction = _b.permissionsChangeInteraction, permissionsRemoveInteraction = _b.permissionsRemoveInteraction;
    var handleOnDelete = react_1.useCallback(function () {
        if (granteePossibilities.remove.enabled) {
            var changedGrantee = tslib_1.__assign(tslib_1.__assign({}, grantee), { permissions: [], inheritedPermissions: [] });
            onDelete(changedGrantee);
            permissionsRemoveInteraction(grantee, mode === "ShareGrantee", granteePossibilities.assign.effective);
            toggleDropdown();
        }
    }, [grantee, onDelete, toggleDropdown, mode, granteePossibilities, permissionsRemoveInteraction]);
    var handleOnChange = react_1.useCallback(function (changedGrantee) {
        permissionsChangeInteraction(grantee, mode === "ShareGrantee", granteePossibilities.assign.effective, changedGrantee.permissions[0]);
        onChange(changedGrantee);
    }, [grantee, onChange, mode, granteePossibilities, permissionsChangeInteraction]);
    if (!isShowDropdown) {
        return null;
    }
    return (react_1.default.createElement(Overlay_1.Overlay, { key: "GranularPermissionsSelect", alignTo: "." + alignTo, alignPoints: overlayAlignPoints, className: "s-granular-permissions-overlay", closeOnMouseDrag: true, closeOnOutsideClick: true, closeOnParentScroll: true, onClose: toggleDropdown },
        react_1.default.createElement(List_1.ItemsWrapper, { smallItemsSpacing: true },
            granteePossibilities.assign.items.map(function (permissionItem) {
                return (!permissionItem.hidden && (react_1.default.createElement(GranularPermissionItem_1.GranularPermissionSelectItemWithBubble, { grantee: grantee, key: permissionItem.id, permission: permissionItem, selectedPermission: selectedPermission, toggleDropdown: toggleDropdown, onChange: handleOnChange, handleSetSelectedPermission: handleSetSelectedPermission, bubbleTextId: permissionItem.tooltip, showBubble: !permissionItem.enabled })));
            }),
            react_1.default.createElement(List_1.Separator, null),
            react_1.default.createElement(RemoveItem, { disabled: !granteePossibilities.remove.enabled, onClick: handleOnDelete, tooltipId: granteePossibilities.remove.tooltip }))));
};
//# sourceMappingURL=GranularPermissionsDropdownBody.js.map